<span *ngIf="webcast.isAutomated && webcast.webcastStatus.isInProgress && webcast.isVodSource">
	{{ countdownTimeDisplay }}
</span>
<span *ngIf="webcast.currentUser.isEventAdminOrModerator && webcast.webcastStatus.isBroadcasting && webcast.isVodSource">
	{{ 'Progress' | translate : { '0': vodProgressDisplay } }}
</span>
